export default __webpack_public_path__ + "static/media/prezencne-pk-9-banner-graphics.7d07a633.svg";